module.exports = "/static/assets/7b80fcafc9fc92e3bd91a895acf4ca7a.gif";